module.exports = __webpack_public_path__ + "assets/images/6f41f39d5e76445a6d00437b910c7506.png";